var app = angular.module('app')
    .filter('stringToDate', formatDate);

function formatDate ($filter) {
    return function (ele, dateFormat){
        return $filter('date')(new Date(ele),dateFormat);
    }
}